import * as types from 'live/redux/actionTypes';

export const liveSetSection = section => ({
  type: types.LIVE_SET_SECTION,
  payload: section,
});
